// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type easyreels_user_upload_urlsMutationVariables = Exact<{
  input: RequestUploadPartURLsInput;
}>;


export type easyreels_user_upload_urlsMutation = { __typename?: 'Mutation', requestUploadPartURLs: { __typename: 'ErrorPayload', message: string } | { __typename: 'RequestUploadPartURLsPayload', parts: Array<{ __typename?: 'UploadPartURL', partNumber: number, url: string }> } };


export function $easyreels_user_upload_urls(variables: easyreels_user_upload_urlsMutationVariables, opts?: { revalidate?: boolean }): easyreels_user_upload_urlsMutation {
	return $easyreels_gql_user_request(`mutation easyreels_user_upload_urls(\u0024input: RequestUploadPartURLsInput!) {
  requestUploadPartURLs(input: \u0024input) {
    __typename
    ... on RequestUploadPartURLsPayload {
      parts {
        partNumber
        url
      }
    }
    ... on ErrorPayload {
      message
    }
  }
}`, variables, opts) as easyreels_user_upload_urlsMutation
}

}
